// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

html {
  background-color: #F3F4FF;
  font-family: Inter, sans-serif;
  margin: 0;
}

body {
  margin: 0;
}

p {
  color: rgba(0, 0, 0, 0.75);
  line-height: 150%;
  margin: 0;
}

button,
.button {
  border-radius: 2.38413rem;
  background: linear-gradient(180deg, #7E91FF 0%, #4F67F3 100%);
  box-shadow: -2px 8px 10px 0 rgba(205, 141, 255, 0.26);
  display: inline-flex;
  padding: 0.75rem 1.25rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border: none;
  color: rgba(255, 255, 255, 0.75);
  font-family: Inter, sans-serif;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
    text-decoration: none;
}

button:hover,
.button:hover {
  box-shadow: none;
  cursor: pointer;
}

button:disabled,
.button:disabled {
    opacity: 0.5;
}

button.primary {
  border-radius: 2rem;
  background: linear-gradient(180deg, #FF8D8D 0%, #F24C27 100%);
  box-shadow: -2px 8px 10px 0 rgba(198, 207, 255, 0.46);
}

button.primary:hover {
  box-shadow: none;
  cursor: pointer;
}

.content {
  width: calc(100% - ( 2 * 100vw/12 ));
  margin: auto;
}

label {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

input,
select {
  border-radius: 0.25rem;
  border: 1px solid #D9D9D9;
  background: #FFF;
  box-shadow: 0  1px 3px 0 rgba(0, 0, 0, 0.10);
  padding: 0.5rem;
  box-sizing: border-box;
}

.error {
  font-size: 0.75rem;
  color: #F24C27;
  font-weight: 400;
  font-style: italic;
  max-width: 400px;
}

label:has(> .error) input,
label:has(> .error) select {
  border: 1px solid #F24C27;
}

.spinner {
    border: 0.25rem solid rgba(255, 255, 255, 0.1);
    border-top: 0.25rem solid white;
    border-radius: 50%;
    width: 1.25rem;
    height: 1.25rem;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(359deg);
    }
}

.error-message {
    color: #f24c27;
    border: 1px solid #fdc6bb;
    background-color: #fde8e3;
    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);
    font-weight: 500;
    padding: 1rem;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    margin: 0.25rem 0 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,yBAAyB;EACzB,6DAA6D;EAC7D,qDAAqD;EACrD,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;IACd,qBAAqB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;IACI,8CAA8C;IAC9C,+BAA+B;IAC/B,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,8CAA8C;IAC9C,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;AAC1B","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\nhtml {\n  background-color: #F3F4FF;\n  font-family: Inter, sans-serif;\n  margin: 0;\n}\n\nbody {\n  margin: 0;\n}\n\np {\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 150%;\n  margin: 0;\n}\n\nbutton,\n.button {\n  border-radius: 2.38413rem;\n  background: linear-gradient(180deg, #7E91FF 0%, #4F67F3 100%);\n  box-shadow: -2px 8px 10px 0 rgba(205, 141, 255, 0.26);\n  display: inline-flex;\n  padding: 0.75rem 1.25rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  border: none;\n  color: rgba(255, 255, 255, 0.75);\n  font-family: Inter, sans-serif;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 150%;\n  transition: all 0.3s ease-in-out;\n  overflow: hidden;\n    text-decoration: none;\n}\n\nbutton:hover,\n.button:hover {\n  box-shadow: none;\n  cursor: pointer;\n}\n\nbutton:disabled,\n.button:disabled {\n    opacity: 0.5;\n}\n\nbutton.primary {\n  border-radius: 2rem;\n  background: linear-gradient(180deg, #FF8D8D 0%, #F24C27 100%);\n  box-shadow: -2px 8px 10px 0 rgba(198, 207, 255, 0.46);\n}\n\nbutton.primary:hover {\n  box-shadow: none;\n  cursor: pointer;\n}\n\n.content {\n  width: calc(100% - ( 2 * 100vw/12 ));\n  margin: auto;\n}\n\nlabel {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\ninput,\nselect {\n  border-radius: 0.25rem;\n  border: 1px solid #D9D9D9;\n  background: #FFF;\n  box-shadow: 0  1px 3px 0 rgba(0, 0, 0, 0.10);\n  padding: 0.5rem;\n  box-sizing: border-box;\n}\n\n.error {\n  font-size: 0.75rem;\n  color: #F24C27;\n  font-weight: 400;\n  font-style: italic;\n  max-width: 400px;\n}\n\nlabel:has(> .error) input,\nlabel:has(> .error) select {\n  border: 1px solid #F24C27;\n}\n\n.spinner {\n    border: 0.25rem solid rgba(255, 255, 255, 0.1);\n    border-top: 0.25rem solid white;\n    border-radius: 50%;\n    width: 1.25rem;\n    height: 1.25rem;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(359deg);\n    }\n}\n\n.error-message {\n    color: #f24c27;\n    border: 1px solid #fdc6bb;\n    background-color: #fde8e3;\n    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);\n    font-weight: 500;\n    padding: 1rem;\n    border-radius: 0.5rem;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n    margin: 0.25rem 0 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
